import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { OrderTypesEnum } from "../../../utils/enums";

export interface InitialState {
  orderTypeParam?: OrderTypesEnum;
}

const initialState: InitialState = {
  orderTypeParam: undefined,
};

const queryParams = createSlice({
  name: "queryParams",
  initialState,
  reducers: {
    setQueryParam: (state, action: PayloadAction<OrderTypesEnum>) => {
      state.orderTypeParam = action.payload;
    },
    removeQueryParam: (state) => {
      state.orderTypeParam = undefined;
    },
  },
});

export const { setQueryParam, removeQueryParam } = queryParams.actions;

export default queryParams.reducer;
